import React, { useEffect } from "react";
import "./selectSubscriptionSection.css";
import ClipLoader from "react-spinners/ClipLoader";
import { Button } from "../../../components";
import useSubscriptionPlans from "../../../hooks/useSubscriptionPlans";

function SelectSubscriptionSection({
  selectedPlan,
  setSelectedPlan,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  setShowPlanNotSelectedWarning,
  setPage,
}) {
  const { subscriptionPlans, loading, fetchSubscriptionPlans } =
    useSubscriptionPlans();

  const paymentMethods = [
    {
      id: "crypto",
      name: "CRIPTOMOEDA",
      description: "BITCOIN / ETHEREUM / USD COIN / TETHER",
    },
    { id: "pix", name: "PIX", description: "TRANSFERÊNCIA INSTANTÂNEA" },
  ];

  const sortedPlans = [...subscriptionPlans].sort((a, b) => a.price - b.price);

  const handleSelect = (plan) => {
    setSelectedPlan({ ...plan });
  };

  const handlePixSubmit = () => {
    setShowPlanNotSelectedWarning(false);
    setPage("pix-section");
  };

  const handleCryptoSubmit = () => {
    setShowPlanNotSelectedWarning(false);
    setPage("crypto-section");
  };

  const handleContinue = () => {
    if (!selectedPlan.id) {
      setShowPlanNotSelectedWarning(true);
      return;
    }
    if (!selectedPaymentMethod) {
      setShowPlanNotSelectedWarning(true);
      return;
    }
    if (selectedPaymentMethod === "pix") {
      handlePixSubmit();
    } else if (selectedPaymentMethod === "crypto") {
      handleCryptoSubmit();
    }
  };

  useEffect(() => {
    fetchSubscriptionPlans();
  }, [fetchSubscriptionPlans]);

  useEffect(() => {
    if (sortedPlans.length === 1 && !selectedPlan.id) {
      setSelectedPlan({ ...sortedPlans[0] });
    }
  }, [sortedPlans, selectedPlan.id, setSelectedPlan]);

  const hasMultiplePlans = sortedPlans.length > 1;

  return (
    <div className="orion__subscription-wrapper">
      {loading ? (
        <ClipLoader
          color="#D42A5B"
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
          className="orion__loading"
        />
      ) : (
        <>
          <div className="orion__selection-section">
            <h3 className="orion__section-title">Forma de pagamento</h3>
            {paymentMethods.map((method) => (
              <div
                className="orion__price-button orion__payment-method-button"
                key={method.id}
              >
                <input
                  type="radio"
                  checked={selectedPaymentMethod === method.id}
                  onChange={() => setSelectedPaymentMethod(method.id)}
                  name="payment"
                />
                <div className="orion__payment-method-texts">
                  <h4 className="orion__price">{method.name}</h4>
                  <small className="orion__duration">
                    {method.description}
                  </small>
                </div>
              </div>
            ))}
          </div>
          {hasMultiplePlans && (
            <div className="orion__selection-section">
              <h3 className="orion__section-title">Selecione um preço</h3>
              {sortedPlans.map((plan) => (
                <div className="orion__price-button" key={plan.id}>
                  <input
                    type="radio"
                    checked={
                      selectedPlan.id === plan.id ||
                      selectedPlan.subscription_plan_id === plan.id
                    }
                    onChange={() => handleSelect(plan)}
                    name="plan"
                  />
                  <h4 className="orion__price">
                    {plan.price + " " + plan.currency}
                  </h4>
                  <small className="orion__duration">
                    ASSINATURA DE {plan.duration_in_days} DIAS
                  </small>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      <Button styleType="filled" onClick={handleContinue} text="Continuar" />
    </div>
  );
}

export default SelectSubscriptionSection;
